import {
  TableSourceJS,
  type ClientApp,
  type TableDetails,
  type TableViewDetails,
} from "target_wasm";
import { isTerminalImportedState } from "components/canvas/utils/roles";

/** A directory or focus id: a view with its table, or a table's own item. */
export type CanvasItem =
  | { kind: "view"; id: string; view: TableViewDetails; table: TableDetails }
  | { kind: "table"; id: string; table: TableDetails };

export function resolveItem(
  clientApp: ClientApp,
  id: string,
): CanvasItem | null {
  try {
    const view = clientApp.get_table_view_details(id);
    if (view)
      return {
        kind: "view",
        id,
        view,
        table: clientApp.table_details_by_table_id(view.table_id),
      };
    return { kind: "table", id, table: clientApp.get_table_details(id) };
  } catch {
    return null;
  }
}

/** Why a table has nothing to act on yet, or null. */
export function tableStateRefusal(source: TableSourceJS): string | null {
  if (source === TableSourceJS.ImportedWaitingForApproval)
    return "waiting for approval";
  if (source === TableSourceJS.ImportedPendingRelease)
    return "awaiting first release";
  if (isTerminalImportedState(source)) return "source unavailable";
  return null;
}
